import { useCallback } from "react";
import { Gender } from "../../../../types";
import Select from "../../Select";

export default function GenderSelect(props: {
  gender?: Gender;
  onChange: (value?: Gender) => void;
}) {
  const getGenderName = useCallback((gender?: Gender) => {
    switch (gender) {
      case "male":
        return "Male";
      case "female":
        return "Female";
      case undefined:
        return "All";
    }
  }, []);

  return (
    <Select
      backgroundColor="black"
      borderColor="dark-gray"
      selected={props.gender}
      items={[
        { value: undefined, label: getGenderName() },
        { value: "male", label: getGenderName("male") },
        { value: "female", label: getGenderName("female") },
      ]}
      onChange={(value) => props.onChange(value as Gender | undefined)}
    />
  );
}
